module.exports = __webpack_public_path__ + "img/cat-empty-salud.4462a79a.svg";